import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuiaCompletoPage from "../pages/artigo/guia-completo-hoobuyspreadsheet/page";
import ArtEconomizar from "../pages/artigo/como-economizar-compras-online/page";
import ArtVsConcorrentes from "../pages/artigo/hoobuyspreadsheet-vs-concorrentes/page";
import ArtSeguranca from "../pages/artigo/seguranca-em-compras-internacionais/page";
import ArtCategorias from "../pages/artigo/categorias-mais-populares-hoobuy/page";
import ArtDicas from "../pages/artigo/dicas-para-compras-online-2026/page";
import ArtAtualizacoes from "../pages/artigo/atualizacoes-hoobuyspreadsheet/page";
import ArtOfertas from "../pages/artigo/como-encontrar-melhores-ofertas/page";
import ArtTutorial from "../pages/artigo/tutorial-hoobuyspreadsheet-iniciantes/page";
import ArtBeneficios from "../pages/artigo/beneficios-planilha-inteligente/page";
import GuiaDeCompras from "../pages/guia-de-compras/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guia-de-compras",
    element: <GuiaDeCompras />,
  },
  {
    path: "/artigo/guia-completo-hoobuyspreadsheet",
    element: <GuiaCompletoPage />,
  },
  {
    path: "/artigo/como-economizar-compras-online",
    element: <ArtEconomizar />,
  },
  {
    path: "/artigo/hoobuyspreadsheet-vs-concorrentes",
    element: <ArtVsConcorrentes />,
  },
  {
    path: "/artigo/seguranca-em-compras-internacionais",
    element: <ArtSeguranca />,
  },
  {
    path: "/artigo/categorias-mais-populares-hoobuy",
    element: <ArtCategorias />,
  },
  {
    path: "/artigo/dicas-para-compras-online-2026",
    element: <ArtDicas />,
  },
  {
    path: "/artigo/atualizacoes-hoobuyspreadsheet",
    element: <ArtAtualizacoes />,
  },
  {
    path: "/artigo/como-encontrar-melhores-ofertas",
    element: <ArtOfertas />,
  },
  {
    path: "/artigo/tutorial-hoobuyspreadsheet-iniciantes",
    element: <ArtTutorial />,
  },
  {
    path: "/artigo/beneficios-planilha-inteligente",
    element: <ArtBeneficios />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;